import React, { Component } from 'react';

export class Simulation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            age: 25,
            pendingCharge: false,
            priorMisdemeanor: false,
            priorFelony: false,
            priorViolentConvictions: 0,
            priorFailuresToAppear: 0,
            priorFailuresToAppearOlder: false,
            currentViolent: false,
            priorSentence: false,
            violentCriminalArrestFlag: false,
            criminalArrestScore: 1,
            failureToAppearScore: 1
        };  
    }

    updateAge(event){
      var newAge = event.target.valueAsNumber
      console.log(event.type)
      if(event.type == "blur" && (newAge < 18 || newAge > 120 || isNaN(newAge))) {
        newAge = 25
      }
      this.setState({
        age: newAge
      },
      this.updateFinalScore
    );   
    }

    updateCurrentViolent(event){

      
      this.setState({
        currentViolent: event.target.checked
      }, 
      this.updateFinalScore);
    }

    updatePendingCharge(event){
      this.setState({
        pendingCharge: event.target.checked
      },
      this.updateFinalScore);
    }

    updatePriorMisdemeanor(event){
      this.setState({
        priorMisdemeanor: event.target.checked
      },
      this.updateFinalScore);
    }

    updatePriorFelony(event){
      this.setState({
        priorFelony: event.target.checked
      },
      this.updateFinalScore);
    }

    updatePriorViolentConvictions(event){
      var newPriorViolentConvictions = event.target.valueAsNumber
      console.log(event.type)
      if(event.type == "blur" && (newPriorViolentConvictions < 0 || newPriorViolentConvictions > 100 || isNaN(newPriorViolentConvictions))) {
        newPriorViolentConvictions = 0
      }
      this.setState({
        priorViolentConvictions: newPriorViolentConvictions
      },
      this.updateFinalScore
    );
  }

    updatePriorFailuresToAppear(event){
      var newPriorFailuresToAppear = event.target.valueAsNumber
      console.log(event.type)
      if(event.type == "blur" && (newPriorFailuresToAppear < 0 || newPriorFailuresToAppear > 100 || isNaN(newPriorFailuresToAppear))) {
        newPriorFailuresToAppear = 0
      }
      this.setState({
        priorFailuresToAppear: newPriorFailuresToAppear
      },
      this.updateFinalScore
    );
    }

    updatePriorFailuresToAppearOlder(event){
      this.setState({
        priorFailuresToAppearOlder: event.target.checked
      },
      this.updateFinalScore);
    }

    updatePriorSentence(event){
      this.setState({
        priorSentence: event.target.checked
      },
      this.updateFinalScore);
    }

    updateFinalScore(){
        //console.log("age: " + this.state.age)
        //console.log("pendingCharge: " + this.state.pendingCharge)
        //console.log("priorMisdemeanor: " + this.state.priorMisdemeanor)
        //console.log("priorFelony: " + this.state.priorFelony)
        //console.log("priorViolentConvictions: " + this.state.priorViolentConvictions)
        //console.log("priorFailurestoAppear " + this.state.priorFailuresToAppear)
        //console.log("priorFailuresToAppearOlder: " + this.state.priorFailuresToAppearOlder)
        //console.log("currentViolent: " + this.state.currentViolent)
        //console.log("priorSentence: " + this.state.priorSentence)

        var newViolentCriminalArrestScore = 0;
        var newCriminalArrestScore = 0;
        var newFailureToAppearScore = 0;
        //var newFinalScore = 0

        //age at time of arrest, if 22 or below add 2
        if(this.state.age <= 22) {
          newCriminalArrestScore += 2;
        }

        //is the current charge considered a violent offense? If so add 2
        if(this.state.currentViolent){
          newViolentCriminalArrestScore += 2;
          if(this.state.age >= 20){
            newViolentCriminalArrestScore += 1;
          }
        }

        //is there an additional pending charge? If so add 3
        if(this.state.pendingCharge){
          newCriminalArrestScore += 3;
          newViolentCriminalArrestScore += 1;
          newFailureToAppearScore += 1;
        }

        //is there a prior misdemeanor conviction? If so add 1
        if(this.state.priorMisdemeanor){
          newCriminalArrestScore += 1

        }

        //is there a prior felony conviction? If so add 1
        if(this.state.priorFelony){
          newCriminalArrestScore += 1
        }

        //prior conviction?
        if(this.state.priorMisdemeanor || this.state.priorFelony){
          newViolentCriminalArrestScore += 1;
          newFailureToAppearScore += 1;
        }

        //number of prior violent convictions,
        // 0 > x <= 2, is add 1
        // 3 >=, add 2
        if(this.state.priorViolentConvictions > 0){
          if(this.state.priorViolentConvictions <= 2){
            newViolentCriminalArrestScore += 1
            newCriminalArrestScore += 1
          } else {
            newViolentCriminalArrestScore += 2
            newCriminalArrestScore += 2
          }
        }

        //number of prior failures to appear
        // x = 1, add 1
        // x >= 2, add 2
        if(this.state.priorFailuresToAppear > 0){
          if(this.state.priorFailuresToAppear == 1){
            newCriminalArrestScore += 1
            newFailureToAppearScore += 2
          } else{
            newCriminalArrestScore += 2
            newFailureToAppearScore += 4
          }
        }

        //is there a prior failure to appear older than two years? if so add 1
        if(this.state.priorFailuresToAppearOlder){
          newFailureToAppearScore += 1
        }

        //is there a prior sentence before incarceration? if so add 2
        if(this.state.priorSentence){
          newCriminalArrestScore += 2
        }

        //set the violent criminal arrest flag
        if (newViolentCriminalArrestScore >= 4) {
          this.setState({
            violentCriminalArrestFlag: true
          });
        } else {
          this.setState({
            violentCriminalArrestFlag: false
          });
        }

        //generate weighted criminal arrest score
        switch(newCriminalArrestScore) {
          case(0):
            newCriminalArrestScore = 1;
            break;
          case(1):
          case(2):
            newCriminalArrestScore = 2;
            break;
          case(3):
          case(4):
            newCriminalArrestScore = 3;
            break;
          case(5):
          case(6):
            newCriminalArrestScore = 4;
            break;
          case(7):
          case(8):
            newCriminalArrestScore = 5;
            break;
          case(9):
          case(10):
          case(11):
          case(12):
          case(13):
            newCriminalArrestScore = 6;
            break;
          default:
            newCriminalArrestScore = -1;
            break;
        }

        //generate weighted failure to appear score
        switch(newFailureToAppearScore) {
          case(0):
          newFailureToAppearScore = 1;
            break;
          case(1):
          newFailureToAppearScore = 2;
            break;
          case(2):
          newFailureToAppearScore = 3;
          case(3):
          case(4):
          newFailureToAppearScore = 4;
            break;
          case(5):
          case(6):
          newFailureToAppearScore = 5
            break;
          case(7):
          newFailureToAppearScore = 6;
            break;
          default:
            newFailureToAppearScore = -1;
            break;
        }

        this.setState({
          criminalArrestScore: newCriminalArrestScore,
          failureToAppearScore: newFailureToAppearScore
        });
    }

  render(){
  return (
    <div className="slide">
      <form>
        <label style={{display: 'block'}}>Age at Current Arrest:&nbsp;
          <input
            type="number" 
            value={this.state.age}
            onChange={(e) => this.updateAge(e)}
            onBlur={(e) => this.updateAge(e)}
            min={18}
            max={100}
          />
        </label>
        <label style={{display: 'block'}}>Current Violent Offense:&nbsp;
          <input
            type="checkbox" 
            value={this.state.currentViolent} 
            onChange={(e) => this.updateCurrentViolent(e)}
          />
        </label>
        <label style={{display: 'block'}}>Pending Charge at the Time of Arrest:&nbsp;
          <input
            type="checkbox" 
            value={this.state.pendingCharge} 
            onChange={(e) => this.updatePendingCharge(e)}
          />
          </label>
          <label style={{display: 'block'}}>Prior Misdemeanor Conviction:&nbsp;
          <input
            type="checkbox" 
            value={this.state.priorMisdemeanor} 
            onChange={(e) => this.updatePriorMisdemeanor(e)}
          />
          </label>
          <label style={{display: 'block'}}>Prior Felony Conviction:&nbsp;
          <input
            type="checkbox" 
            value={this.state.priorFelony} 
            onChange={(e) => this.updatePriorFelony(e)}
          />
          </label>
          <label style={{display: 'block'}}>Number of Prior Violent Convictions:&nbsp;
          <input
            type="number" 
            value={this.state.priorViolentConvictions}
            onChange={(e) => this.updatePriorViolentConvictions(e)}
            onBlur={(e) => this.updatePriorViolentConvictions(e)}
            min={0}
            max={100}
          />
        </label>
        <label style={{display: 'block'}}>Prior Failure(s) to Appear Pretrial in Past 2 Years:&nbsp;
          <input
            type="number" 
            value={this.state.priorFailuresToAppear}
            onChange={(e) => this.updatePriorFailuresToAppear(e)}
            onBlur={(e) => this.updatePriorFailuresToAppear(e)}
            min={0}
            max={100}
          />
        </label>
        <label style={{display: 'block'}}>Prior Failure to Appear Pretrial Older than 2 Years:&nbsp;
          <input
            type="checkbox" 
            value={this.state.priorFailuresToAppearOlder} 
            onChange={(e) => this.updatePriorFailuresToAppearOlder(e)}
          />
          </label>
          <label style={{display: 'block'}}>Prior Sentence to Incarceration:&nbsp;
          <input
            type="checkbox" 
            value={this.state.priorSentence} 
            onChange={(e) => this.updatePriorSentence(e)}
          />
          </label>
      </form>
      <div>
        <span>Violent Criminal Arrest Flag: </span>
        <span>{this.state.violentCriminalArrestFlag + ""}</span>
        <br />
        <span>New Criminal Arrest Score: </span>
        <span>{this.state.criminalArrestScore}</span>
        <br />
        <span>Failure to Appear Score: </span>
        <span>{this.state.failureToAppearScore}</span>
      </div>
    </div>
  );
  }
}
